import { Box } from 'native-base';
import { useEffect } from 'react';
import { useRecoilValue } from 'recoil';

import { useToastCreator } from '../../../hooks/useToastCreator';
import { productItemState, productStatusState } from '../../../store/product/atom';
import { DynamicAssetSelected } from '../DynamicAssetSelected';
import { DynamicAssetWrapper } from '../DynamicAssetWrapper';

export const ProductStep = () => {
  const productItem = useRecoilValue(productItemState);

  const productStatus = useRecoilValue(productStatusState);

  const { showToast } = useToastCreator('product-toast');

  const getMessage = (
    valueChanged: boolean,
    quantityChanged: boolean,
    productIsEqual: boolean,
    scheduleDateIsUpdated: boolean
  ) => {
    if (valueChanged && productIsEqual) {
      return 'O valor aplicado foi alterado com sucesso!';
    }
    if (quantityChanged && productIsEqual) {
      return 'A quantidade aplicada foi alterada com sucesso';
    }
    if (scheduleDateIsUpdated && productIsEqual) {
      return 'Data de solicitação alterada com sucesso!';
    }
    return 'Seu produto foi alterado com sucesso!';
  };

  useEffect(() => {
    if (productItem.previous && Object.keys(productItem.previous)?.length > 0) {
      const amountIsUpdated = productItem.current.orderValue !== productItem.previous.orderValue;
      const quantityIsUpdated =
        productItem.current.orderQuantity !== productItem.previous.orderQuantity;
      const productHasChanged = productItem.current.productId === productItem.previous.productId;
      const scheduleDateIsUpdated =
        productItem.current.scheduleDate !== productItem.previous.scheduleDate;
      const message = getMessage(
        amountIsUpdated,
        quantityIsUpdated,
        productHasChanged,
        scheduleDateIsUpdated
      );

      showToast('success', 'Tudo certo!', message, {
        duration: 3000,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [productItem]);

  return (
    <Box>
      <DynamicAssetSelected />

      {productStatus.status !== 'completed' && productStatus.status !== 'locked' && (
        <DynamicAssetWrapper />
      )}
    </Box>
  );
};
